module.exports = __webpack_public_path__ + "img/attendance.08e2f83b.png";